import {createAsyncThunk} from "@reduxjs/toolkit";
import {httpRequestFunc} from "../../../common/config/httpClient";
import {UserBetHistory} from "../../../common/api/userApi";
import {GameDirectLunch, GameGetLists, GameLunch} from "../../../common/api/gameApi";
import {SetOpenGame} from "./gameSlice";
import {SetProcessStatus} from "../global";
import {NotificationMessage} from "../../../common/functions/notification";
import { useState } from "react";


export const GameListsThunk = createAsyncThunk(
    'game/GameListsThunk',
    async (filter, baseThunk) => {
        try {
            const response = await httpRequestFunc(baseThunk, GameGetLists(filter), false, false)
            if (response.status === 200) {
                return response.data
            }
        } catch (e) {
        }
    }
)

export const GameListsRecommendThunk = createAsyncThunk(
    'game/GameListsRecommendThunk',
    async (filter, baseThunk) => {
        try {
            const response = await httpRequestFunc(baseThunk, GameGetLists(filter), false, false)
            if (response.status === 200) {
                return response.data
            }
        } catch (e) {
        }
    }
)

export const GameLunchThunk = createAsyncThunk(
    'game/GameLunchThunk',
    async ({id, code, mobile}, baseThunk) => {
        try {
            const response = await httpRequestFunc(baseThunk, GameLunch(id, code, mobile), false, true)
            if (response.status === 200) {
                console.log(response?.data)
                if (typeof response?.data?.url !== `undefined` && response?.data?.url !== `` && response?.data?.url !== null) {
                    //window.location.href = response?.data?.url
                    if (response?.data && response?.data.url) {
                        const url = new URL(response.data.url);
                        const searchParams = new URLSearchParams(url.search);
                        const langParam = localStorage.getItem("selectedOption") || "TH";

                        // เปลี่ยนแปลงค่า params language เป็นค่าใหม่ (เช่นเปลี่ยนเป็น 'en')
                        searchParams.set('language', langParam.toLowerCase());

                        searchParams.get('lang');
                        
                        searchParams.set('lang', langParam.toLowerCase());
                  
                        
                  
                        // นำ URL ใหม่ไปใช้งาน (เช่นนำไปใช้ในการ redirect หรือใช้ในการทำ request อื่นๆ)
                        console.log(url.toString());

                        let domain = url.hostname;
                        
                        
                        domain === 'dev.hippo168.com' && langParam.toLowerCase() === 'vn' ? searchParams.set('lang', 'vt') : searchParams.set('lang', langParam.toLowerCase())

                        // สร้าง URL ใหม่
                        url.search = searchParams.toString();

                        window.location.href = url.toString()
                      }
                } else {
                    NotificationMessage(`ไม่สามารถเปิดเกมส์ได้ กรุณาติดต่อทีมงาน`, `warning`)
                }
                return;
                baseThunk.dispatch(SetOpenGame(response?.data?.url))
                return response.data
            }
        } catch (e) {
        }
    }
)

export const GameDirectLunchThunk = createAsyncThunk(
    'game/GameDirectLunchThunk',
    async ({endpoint, data}, baseThunk) => {
        try {
            const response = await httpRequestFunc(baseThunk, GameDirectLunch(endpoint, data), false, true)
            if (response.status === 200) {
                const data = response?.data
                if (typeof data?.url !== `undefined` && data?.url !== ``) {
                    window.location.href = data?.url
                    return
                }
                baseThunk.dispatch(SetProcessStatus({status: 'error', message: `ไม่สามารถเปิดเกมส์ได้`}))
                return;
                // baseThunk.dispatch(SetOpenGame(response?.data?.url))
                // return response.data
            }
        } catch (e) {
        }
    }
)
